import React from 'react';
import { UIGameActionButton } from '../../../common/UIGameActionButton/index.ts';
import { T } from '@colonist/ui';
import { ACTION_BUTTON_IDS, useActionButtonCommonErrors } from '../utils.ts';
import IconTrade from '@static/images/icon_trade.svg';
import IconX from '@static/images/icon_x.svg';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { HiddenUIElement } from '@colonist/game-beginner-mode';
import clsx from 'clsx';
import styles from '../UIGameActionButtonContainer.module.scss';
import { GameAction } from '@colonist/game-base-types';
import { TradeActions } from '@colonist/game-mechanic-validators';
import { ActionState, TurnState } from '@colonist/game-states';
import { useCurrentStateValidator } from '../../../store/selectors/useCurrentStateValidator.ts';
export const UIGameActionButtonTrade = ({ className, hideTooltip })=>{
    const isShowTradePanel = useGameStore((state)=>state.gameTrade.isShowTradePanel);
    const setIsShowTradePanel = useGameStore((state)=>state.gameTrade.setIsShowTradePanel);
    const sendUpdateTradeResponse = useGameStore((state)=>state.gameTradeOffers.sendUpdateTradeResponse);
    const setCounterOffer = useGameStore((state)=>state.gameTrade.setCounterOffer);
    const counterOffer = useGameStore((state)=>state.gameTrade.counterOffer);
    const beginnerActionState = useGameStore((state)=>state.gameBeginnerHint.beginnerActionState);
    const currentState = useGameStore((state)=>state.gameState.currentState);
    const { errorHelperText, hasCommonErrors } = useActionButtonCommonErrors();
    const isHidden = beginnerActionState === null || beginnerActionState === void 0 ? void 0 : beginnerActionState.hiddenUIElements.includes(HiddenUIElement.Trade);
    const isSpecialBuildPhase = currentState.turnState == TurnState.SpecialBuildPhase;
    const isNotBeginnerGameActionTrade = beginnerActionState != null && (beginnerActionState === null || beginnerActionState === void 0 ? void 0 : beginnerActionState.type) != GameAction.CreateTrade;
    const isSomePlayerSelectingToDiscard = useCurrentStateValidator().isSomePlayerInActionState(ActionState.SelectCardsToDiscard);
    const disabled = (hasCommonErrors || isHidden || isNotBeginnerGameActionTrade || isSpecialBuildPhase || isSomePlayerSelectingToDiscard) && !isShowTradePanel;
    const isDisabledDueToDiscard = isSomePlayerSelectingToDiscard && !isShowTradePanel;
    const getTradeErrorHelperText = ()=>{
        if (isSomePlayerSelectingToDiscard) return {
            key: 'strings:game.errors.playersDiscarding'
        };
        if (errorHelperText) return errorHelperText;
        return undefined;
    };
    const tradeHelperText = getTradeErrorHelperText();
    const onClick = ()=>{
        if (disabled) return;
        const newIsShowTradePanel = !isShowTradePanel;
        setIsShowTradePanel(newIsShowTradePanel);
        if (newIsShowTradePanel === false && counterOffer != undefined) {
            sendUpdateTradeResponse({
                id: counterOffer.tradeId,
                response: TradeActions.CounterOfferCreatedOrCanceled
            });
            setCounterOffer(undefined);
        }
    };
    const icon = isShowTradePanel ? IconX : IconTrade;
    const shouldShowTooltip = !isShowTradePanel && !hideTooltip;
    return /*#__PURE__*/ React.createElement(UIGameActionButton, {
        className: clsx(className, {
            [styles.hidden]: isHidden
        }),
        id: ACTION_BUTTON_IDS.trade,
        disabled: disabled,
        shakingAnimation: isDisabledDueToDiscard,
        helperText: tradeHelperText,
        iconPath: icon,
        tooltipTitle: shouldShowTooltip ? /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.trade"
        }) : undefined,
        onClick: onClick
    });
};
